import React from 'react';
import { Grid, Box, Typography, Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';

const WebMetricsInfo = () => {
    const { dtcData } = useSelector((state) => state.paidSearch);
    const { company } = useSelector((state) => state.company);
    const {
        isPaidSearchLoading,
        totalReach = 0,
        totalEngagement = 0,
        totalCTR = 0,
        totalCost = 0
    } = dtcData || {};
    const { isCostApiLoading, totalPaidSearchCPC=0 } = useSelector((state) => state.webMatrix);
    const isLoading = ( isCostApiLoading || isPaidSearchLoading);

    const gridItems = {
        61: [
            {
                label: 'Total Reach', value: totalReach, visible: true 
            },
            {
                label: 'Total Engagement', value: totalEngagement, visible: true 
            },
            {
                label: 'Total CTR', value: `${totalCTR}%`, visible: true 
            },
            {
                label: 'Total CPC', value: `$${totalPaidSearchCPC}`, visible: false
            }
        ],
        165: [
            {
                label: 'Total Reach', value: totalReach, visible: true 
            },
            {
                label: 'Total Engagement', value: totalEngagement, visible: true 
            },
            {
                label: 'Total CTR', value: `${totalCTR}%`, visible: true 
            },
            {
                label: 'Total CPC', value: `$${totalPaidSearchCPC}`, visible: false
            }
        ],
        default: [
            {
                label: 'Total Reach', value: totalReach, visible: true 
            },
            {
                label: 'Total Engagement', value: totalEngagement, visible: true 
            },
            {
                label: 'Total CTR', value: `${totalCTR}%`, visible: true 
            },
            {
                label: 'Total CPC', value: `$${totalPaidSearchCPC}`, visible: false
            }
        ]
    };

    const config = gridItems[company.id] || gridItems.default;
    const visibleItems = config.filter(item => item.visible);
    const xsValue = 12 / visibleItems.length;

    return (
        <Grid container className="flex-row-space-between" spacing={1} xs={12}>
            {isLoading ? (
                Array.from({ length: visibleItems.length }).map((_, index) => (
                    <Grid item key={index} xs={xsValue}>
                        <Box className="padding-16px bg-gray-50 br-16px">
                            <Box className="flex-row-space-between-center gap-8">
                                <Skeleton height={18} variant="text" width={140} />
                            </Box>
                            <Box>
                                <Skeleton height={32} variant="text" width={50} />
                            </Box>
                        </Box>
                    </Grid>
                ))
            ) : (
                visibleItems.map((item, index) => (
                    <Grid item key={index} xs={xsValue}>
                        <Box className="padding-16px bg-gray-50 br-16px">
                            <Box className="flex-row-space-between-center gap-8">
                                <Typography className="text-400fw-14fs-20lh-bg-gray-500">
                                    {item.label}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography className="display-sm-semi-bold gray-900 text-center mt-1">
                                    {item.value}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                ))
            )}
        </Grid>
    );
};

export default WebMetricsInfo;
